import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Dashboard.css';
import './Setup.css';

function Login({ onGoToSignup, onGoToForgotPassword }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    login(email, password)
      .catch((err) => setError(err.response?.data?.detail || 'Login failed'))
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="setup-page">
      <div className="setup-card">
        <div className="setup-brand">
          KROSI<span>FIN</span>
        </div>
        <div className="setup-brand-sub">by NeedCFO</div>
        <h1 className="setup-title">Sign in</h1>
        <p className="setup-subtitle">Compliance + Accounting + ERP</p>

        {error && <p className="dash-error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="field-group">
            <span className="field-label">Email</span>
            <input
              className="field-input"
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field-group">
            <span className="field-label">Password</span>
            <input
              className="field-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="dash-btn-row">
            <button className="dash-btn dash-btn-orange" type="submit" disabled={submitting}>
              {submitting ? 'Signing in...' : 'Sign In'}
            </button>
          </div>
        </form>

        {onGoToForgotPassword && (
          <p className="setup-subtitle" style={{ marginTop: 16 }}>
            <button type="button" className="setup-link-btn" onClick={onGoToForgotPassword}>
              Forgot password?
            </button>
          </p>
        )}

        {onGoToSignup && (
          <p className="setup-subtitle" style={{ marginTop: 16 }}>
            New here?{' '}
            <button type="button" className="setup-link-btn" onClick={onGoToSignup}>
              Create an account
            </button>
          </p>
        )}
      </div>
    </div>
  );
}

export default Login;
